export enum GeocoderAddressComponentType {
  Locality = 'locality',
  Sublocality = 'sublocality',
  PostalCode = 'postal_code',
  StreetNumber = 'street_number',
  Route = 'route',
  AdministrativeAreaLevel1 = 'administrative_area_level_1',
}
